import { useAuth } from '@/hooks/useAuth';
import { hasPermission } from '@/services/rbac.service';
import type { Permission } from '@/types/rbac';
import { useEffect, useState } from 'react';

/**
 * Check if current user has a specific permission
 */
export function usePermission(permission: Permission): {
  allowed: boolean;
  loading: boolean;
} {
  const { user } = useAuth();
  const [allowed, setAllowed] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setAllowed(false);
      setLoading(false);
      return;
    }

    let mounted = true;

    async function check() {
      const result = await hasPermission(user!.id, permission);
      if (mounted) {
        setAllowed(result);
        setLoading(false);
      }
    }

    check();
    return () => { mounted = false; };
  }, [user, permission]);

  return { allowed, loading };
}
